import React from "react";
import { NavLink } from "react-router-dom";

const NavigationLinkAbs = ({ filter, navLinkClicked, style, children }) => (
  <div>
    <a
      className={"nav-link"}
      // exact
      // to={filter === 'SHOW_ALL' ? '/' : `/${filter}`}
      href={`${filter}`}
      // activeStyle={{
      //   textDecoration: "none",
      //   color: "black",
      // }}
      style={style}

      // onClick={(e) => {
      //   console.log("navlink clickedksld fl");
      //   navLinkClicked();
      // }}
    >
      {children}
    </a>
  </div>
);

export default NavigationLinkAbs;
